export default __webpack_public_path__ + "locales/ru/UploadPanel.json?hash=4531c7f5ce6a41c2c5c3b7c30fdb3b82";